import React from 'react'

const Loader = () => {
  return (
    <>
        <div className="logo_loader">
           <div className='text-center col-lg-4'>
                <img src="./images/logo.png" alt="" />
                <h5 className='mt-4'>Loading...</h5>
           </div>
        </div>
    </>
  )
}

export default Loader